import styled from 'styled-components'

interface PnlStatusStyledProps {
    status: string
}

export const PnlStatusStyled = styled.div<PnlStatusStyledProps>`
    align-items: center;
    color: ${(props) => {
        if (props.status === 'CURRENT') return props.theme.colors.notification
        if (props.status === 'RETRYING') return props.theme.colors.error
        if (props.status === 'UNAVAILABLE') return props.theme.colors.dark[1]
        return props.theme.colors.warning
    }};
    display: flex;
    font-size: 12px;
    gap: 6px;
    margin-right: 12px;
    white-space: nowrap;
`
